import script from "./Cobertura.vue?vue&type=script&setup=true&lang=js"
export * from "./Cobertura.vue?vue&type=script&setup=true&lang=js"

import "./Cobertura.vue?vue&type=style&index=0&id=5af40e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af40e6a"]])

export default __exports__